var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/32px/Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.3857825,30 L2.61578252,30 C1.66278252,30 0.813782521,29.51 0.343782521,28.689 C-0.119217479,27.88 -0.114217479,26.918 0.356782521,26.115 L13.7407825,3.288 C14.2137825,2.482 15.0587825,2 16.0007825,2 C16.9427825,2 17.7877825,2.482 18.2597825,3.289 L31.6447825,26.116 C32.1167825,26.92 32.1217825,27.882 31.6587825,28.69 C31.1887825,29.51 30.3387825,30 29.3857825,30 Z M2.08178252,27.127 C1.93678252,27.374 2.01778252,27.589 2.07878252,27.695 C2.13178252,27.787 2.28878252,28 2.61578252,28 L29.3857825,28 C29.7137825,28 29.8707825,27.786 29.9237825,27.694 C29.9847825,27.589 30.0657825,27.373 29.9207825,27.127 L16.5347825,4.3 C16.3757825,4.03 16.1087825,4 16.0007825,4 C15.8927825,4 15.6257825,4.029 15.4667825,4.3 L2.08178252,27.127 Z M16.0007825,21.01 C15.4487825,21.01 15.0007825,20.563 15.0007825,20.01 L15.0007825,12.01 C15.0007825,11.458 15.4487825,11.01 16.0007825,11.01 C16.5527825,11.01 17.0007825,11.458 17.0007825,12.01 L17.0007825,20.01 C17.0007825,20.563 16.5527825,21.01 16.0007825,21.01 Z M16.0007825,25.01 C15.7407825,25.01 15.4807825,24.9 15.2907825,24.72 C15.1107825,24.53 15.0007825,24.27 15.0007825,24.01 C15.0007825,23.75 15.1107825,23.489 15.2907825,23.3 C15.6607825,22.93 16.3407825,22.93 16.7107825,23.3 C16.8907825,23.489 17.0007825,23.75 17.0007825,24.01 C17.0007825,24.27 16.8907825,24.53 16.7107825,24.72 C16.5207825,24.9 16.2707825,25.01 16.0007825,25.01 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/32px/Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "error_32px",
    fill: "#E67670",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8a5d26be1e852a68b6d06844aaf951d3.svg";
export { ForwardRef as ReactComponent };